import React, { useCallback, useState } from "react";
import { Button, Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios, { AxiosError, AxiosResponse } from "axios";
import moment from "moment";
import { useToast } from "../../../hooks/toast";
import { IActionModalProps } from "..";
import api from "../../../services/api";
import ProjectStatus from "../../../enums/ProjectStatus";

const { Text } = Typography;

interface IActivityFormData {
  identifier: string;
  description: string;
  hours?: number;
  type: string;
  consultant_id?: string;
  project_id: string;
  allocation_month: moment.Moment;
  estimator_id: string;
}

const ConcludeProject: React.FC<IActionModalProps> = ({
  project,
  handleUpdateProject,
}) => {
  const { t } = useTranslation(["activities"]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const { addToast } = useToast();

  const handleClose = useCallback(
    (status?: ProjectStatus) => {
      if (status) {
        const concludeProject = { ...project, status };
        handleUpdateProject(concludeProject);
      }

      setVisible(false);
    },
    [handleUpdateProject],
  );

  const generateErrorToast = useCallback(
    (response: AxiosResponse | undefined) => {
      let description;

      switch (response?.status) {
        case 403:
          description = "O usuário logado não é gestor";
          break;
        case 404:
          description = "O projeto não foi encontrado";
          break;
        default:
          description =
            "Ocorreu um erro ao conclusão o projeto, tente novamente";
      }

      addToast({
        type: "error",
        title: "Erro em atualizar projeto",
        description,
      });
    },
    [addToast],
  );

  const handleShowModal = useCallback(() => {
    setVisible(true);
  }, []);

  const handleSubmit = useCallback(async () => {
    setLoading(old => !old);
    try {
      await api.patch(`/projects/${project?.id}/config/status`, {
        status: ProjectStatus.Concluded,
      });
      addToast({
        type: "success",
        title: "Conclusão de projeto",
        description: "Projeto concluído com sucesso",
      });

      handleClose(ProjectStatus.Concluded);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const serverError = err as AxiosError;
        generateErrorToast(serverError.response);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(old => !old);
    }
  }, [project?.id, addToast, handleClose, generateErrorToast]);

  return (
    <>
      <Modal
        title={t("Concluir Projeto")}
        visible={visible}
        onOk={() => handleSubmit()}
        onCancel={() => handleClose()}
        okButtonProps={{ htmlType: "submit", loading }}
        getContainer={false}
        forceRender
      >
        <Text>
          Você tem certeza que deseja concluir o projeto{" "}
          <Text strong> &quot;{project?.short_description}&quot; </Text>
        </Text>
      </Modal>
      <Button type="primary" onClick={handleShowModal}>
        {t("Concluir")}
      </Button>
    </>
  );
};

export default ConcludeProject;
